export default "__VITE_ASSET__DEnXhwgi__"